// The series and signal-suggestion routes (C-33: network I/O lives in `services/` or
// `lib/apiClient`). Each function is the `fetch` its call site made, moved here unchanged and
// returning the `Response` untouched, so the caller keeps its own status handling (the
// availability verdicts in `lib/series/seriesAvailability.js` read ok/status off it).

const JSON_HEADERS = { "Content-Type": "application/json" };

/**
 * `GET /api/series/:name[?resDate=&ssid=]`: a series' points and server projection. `ssid`
 * fetches a specific signals-service signal by id (a clicked suggestion, whose corpus name
 * cannot round-trip through the name → id derivation).
 */
export function fetchSeries(
  name: string,
  { resDate = null, ssid = null }: { resDate?: string | null; ssid?: string | null } = {},
): Promise<Response> {
  const params = new URLSearchParams();
  if (resDate) params.set("resDate", resDate);
  if (ssid) params.set("ssid", ssid);
  const qs = params.toString() ? `?${params}` : "";
  return fetch(`/api/series/${encodeURIComponent(name)}${qs}`);
}

/** `GET /api/series-resolve?q=`: a typed name resolved to a known series name. */
export function resolveSeriesName(q: string): Promise<Response> {
  return fetch(`/api/series-resolve?q=${encodeURIComponent(q)}`);
}

/** `POST /api/signals/suggest`: signal suggestions for a question, abortable. */
export function postSignalSuggest(
  body: Record<string, unknown>,
  { signal }: { signal?: AbortSignal } = {},
): Promise<Response> {
  return fetch("/api/signals/suggest", {
    method: "POST",
    headers: JSON_HEADERS,
    body: JSON.stringify(body),
    signal,
  });
}
